import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

import { stations } from '../global-styles'
import { getMockDepartures } from '../../other/mockData'

import FailureState from '../../States/Failure/FailureState'
import SuccessState from '../../States/Success/SuccessState'

const apiURL = process.env.REACT_APP_DEPARTURES_API_URL
const depatureUrls: { [key: string]: string } = {
    [stations.stockholm]: `${apiURL}/upcomingDepartures/stockholm`,
    [stations.arlandaSouth]: `${apiURL}/upcomingDepartures/arlanda-south`,
    [stations.arlandaNorth]: `${apiURL}/upcomingDepartures/arlanda-north`
}
const stationDestination: { [key: string]: string } = {
    [stations.stockholm]: 'Arlanda',
    [stations.arlandaSouth]: 'Stockholm',
    [stations.arlandaNorth]: 'Stockholm'
}

let fakeStep = 4

// A PureComponent
const Departures = React.memo<{
    station: string
    count: number
}>(
    ({ station, count }) => {
        const [departureRequest, setDepartureRequest] = useState<any>({})

        useEffect(() => {
            if (count === 0) {
                const mockData = getMockDepartures(fakeStep)

                // If we mock the data, no need to fetch
                if (mockData) {
                    setDepartureRequest({ type: 'Success', data: mockData })
                    fakeStep = fakeStep < 10 ? fakeStep + 1 : 0
                    return
                }

                fetch(depatureUrls[station])
                    .then(async response => [response.status, await response.json()])
                    .then(([status, data]) => {
                        if (status === 200) {
                            setDepartureRequest({ type: 'Success', data: mockData || data })
                        } else {
                            setDepartureRequest({ type: 'Failure', data: '[Error message 3]' })
                        }
                    })
                    .catch(e =>
                        setDepartureRequest({
                            type: 'Failure',
                            data: '[Error message 4]'
                        })
                    )
            }

            // TODO: When switching to Critical - this fetch updates a state on a compnent not mouted!
        }, [count, station])

        // END Handle updates ever X seconds

        let content = null

        if (departureRequest.type === 'Failure') {
            content = <FailureState />
        } else if (departureRequest.type === 'Success') {
            if (departureRequest.data && departureRequest.data.length) {
                content = <SuccessState data={departureRequest.data} destination={stationDestination[station]} />
            } else {
                content = <FailureState />
            }
        }

        return <DeparturesWrapper>{content}</DeparturesWrapper>
    },
    (prevProps, nextProps) => nextProps.count > 1 // Need both 0 and 1 for fetch effect to trigger
)

export default Departures

const DeparturesWrapper = styled.div`
    width: 100vw;
    height: 100vh;
`
